import React from "react";
import { createRoot } from "react-dom/client";
import "@fontsource-variable/fraunces";
import "@fontsource-variable/plus-jakarta-sans";
import "./styles.css";
import "./web"; // browser-only extras start listening before the first screen
import { App } from "./App";

createRoot(document.getElementById("root")!).render(<React.StrictMode><App/></React.StrictMode>);
